import { Box, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import location from "../../assets/icon/location.png";
import Footer from "../../common/Footer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import course_img from "../../assets/img/courseImg.png";
import { useNavigate } from "react-router";
import { getAllCourses } from "./coursesApi";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../common/debounce";
import SearchIcon from "@mui/icons-material/Search";
import { setchangeRoll } from "../../app/store/reducer";

export default function CourseList() {
  const navigate = useNavigate();
  const [allCourse, setAllCourse] = useState();
  const searchValue = useSelector((state) => state.reducer.searchValue);
  const [searchhere, setSearchHere] = useState("");
  const debouncedSearchHere = useDebounce(searchhere, 500);
  const debouncedSearchValue = useDebounce(searchValue, 500);
    const dispatch = useDispatch();

  const getCourses = async () => {
    const payload = {
      search1: [
        {
          value: debouncedSearchValue || debouncedSearchHere,
        },
      ],
      search2: [
        {
          value: "",
        },
      ],
      search3: [
        {
          value: "",
        },
      ],
    };

    // console.log("bbbb", billerId);

    getAllCourses(payload, (data) => {
      // console.log("Courses- ", data.data.data.list);
      setAllCourse(data.data.data.list);
    });
  };
  useEffect(() => {
    getCourses();
  }, [debouncedSearchValue, debouncedSearchHere]);

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  return (
    <>
      <Box
        sx={{
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
          p: { xs: 2, sm: 3, md: 5 },
          px: { xs: 2, sm: 6, md: 12 },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Typography
                      sx={{
                        fontSize: { xs: 18, sm: 22, md: 28 },
                        fontWeight: 500,
                        display: { sm: "block", xs: "none" },
                      }}
                    >
                      Course Available For You
                    </Typography>
          
                    <TextField
                      placeholder={`Search ...`}
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <SearchIcon
                            sx={{ cursor: "pointer" }}
                            // onClick={handleSearchClick}
                          />
                        ),
                      }}
                      sx={{
                        backgroundColor: "#fff",
                        "& .MuiInputBase-input": {
                          padding: "7.5px 10px !important",
                          fontFamily: "Kanit",
                        },
                        display: { sm: "none", xs: "block" },
          
                        "& .MuiInputBase-input::placeholder": {
                          color: "#585858",
                          opacity: 1,
                        },
                      }}
                      // onClick={handleSearchClick}
                      value={searchhere}
                      // onChange={(e) =>
                      //   dispatch(setSearchValue(e.target.value))
                      // }
          
                      onChange={(e) => setSearchHere(e.target.value)}
                      // onClick={(e) => handleSearchClickOrType(e)}
                    />
        </Box>

        <Grid container spacing={{ xs: 2, sm: 3 }}>
          {allCourse?.map((course) => {
            return (
              <Grid item xs={12} sm={6} md={6} lg={4} key={course.id}>
                <Box
                  onClick={() => {
                    navigate(`/coursedetails/${course.id}`);
                  sessionStorage.setItem("mode", "customer");
                    dispatch(setchangeRoll("customer"));
                  }}
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#EAEAFF",
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "16px", sm: "22px", md: "27px" },
                        fontWeight: 600,
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        flex: 1,
                      }}
                    >
                      {course.courseName || "-"}
                    </Typography>

                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        borderRadius: "50%",
                        backgroundColor: "#E6E8FF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 600,
                      }}
                    >
                      {course.instituteLogo && (
                        <Box
                          component="img"
                          src={course.instituteLogo}
                          height={60}
                          alt=""
                          borderRadius={10}
                        />
                      )}
                    </Box>
                  </Box>

                  {/* Course ID */}
                  <Typography
                    sx={{
                      fontSize: { xs: "13px", sm: "16px", md: "18px" },
                      fontWeight: 500,
                      // mt: 0.5,
                      color: "#555555",
                    }}
                  >
                    (Course Id: {course.id})
                  </Typography>

                  {/* Salon Name */}
                  <Typography
                    sx={{
                      fontSize: { xs: "13px", sm: "16px", md: "18px" },
                      fontWeight: 600,
                      mt: 0.5,
                    }}
                  >
                    {course.instituteName}
                  </Typography>

                  {/* Details */}
                  <Box sx={{ mt: 1 }}>
                    {/* Location */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        component="img"
                        src={location}
                        alt="Location"
                        sx={{ width: 20, height: 20 }}
                      />
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {course.courseCity}
                      </Typography>
                    </Box>

                    {/* Duration */}
                    <Box sx={{ display: "flex", gap: 1, mt: 0.5 }}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        Duration:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {course.courseDuration} months
                      </Typography>
                    </Box>

                    {/* Starting From */}
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        Starting From:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {formatDate(course.courseStartDate)}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Already Applied */}

                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 10,
                      right: 16,
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    {/* <CheckCircleIcon sx={{ fontSize: 16, color: "#27A42D" }} /> */}
                    <Typography
                      sx={{
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#000000",
                      }}
                    >
                      {formatDate(course?.createdDate)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>

      <Box sx={{ pt: 10 }}>
        <Footer />
      </Box>
    </>
  );
}
